import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { compose } from 'redux';
import Linkify from 'react-linkify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Panel } from 'react-bootstrap';

import withRoute from 'containers/withRoute';
import { EMBEDDED } from 'containers/App/constants';
import withRoutes from 'containers/Routes/withEntity';
import InfoControlPanel from 'components/InfoControlPanel';
import CloseButton from 'components/CloseButton';
import ShareLink from 'components/ShareLink';
import Distance from 'components/Distance';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import messages from './messages';

function RouteInfo(props) {
  const { currentRoute, routeId, intl, goTo } = props;
  if (!currentRoute || currentRoute.id !== routeId) {
    return null;
  }
  const hide = () => goTo('/home');
  const gpxLink = `https://api.runnermaps.nl/route_${
    currentRoute.id
  }.gpx?type=track`;
  return (
    <InfoControlPanel>
      <Panel.Heading>
        {!EMBEDDED && <CloseButton onClose={hide} />}
        <h2>{currentRoute.title}</h2>
        <div className="flex-description">
          <div>
            {currentRoute.city}
            {', '}
            <Distance distance={currentRoute.distance} />
          </div>
          <a href={gpxLink} title={intl.formatMessage(messages.gpxTrack)}>
            <span className="hidden-xs">
              <FormattedMessage {...messages.export} />
            </span>
            <FontAwesomeIcon icon="external-link-alt" size="lg" fixedWidth />
          </a>
          <ShareLink bsSize="small" className="py-0 pe-0 pr-0" />
        </div>
      </Panel.Heading>
      {currentRoute.description && (
        <Panel.Body>
          <Linkify>{currentRoute.description}</Linkify>
        </Panel.Body>
      )}
    </InfoControlPanel>
  );
}

RouteInfo.propTypes = {
  routeId: PropTypes.number.isRequired,
  currentRoute: PropTypes.object,
  goTo: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default compose(
  withRoute,
  withRoutes,
  injectIntl,
)(RouteInfo);
